import React from 'react'
import styled from 'styled-components'

import DrawerMenu from '../DrawerMenu'
import MenuWrapper from '../MenuWrapper'
import NavLink from './NavLink'
import MenuSocial from 'src/components/shared/MenuSocial'
import { NavButton } from 'src/components/shared/buttons'
import { colors } from 'src/styles/variables'
import { media } from 'src/styles/util'
import { StretchCTAButton } from 'src/components/shared/buttons'
import { navigate } from 'gatsby'

const List = styled.div`
  color: ${colors.lightText};
  border-top: 1px solid ${colors.lightText};
  height: fit-content;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  padding: 40px 0 40px 0;
  margin-top: 0;
  grid-gap: 30px;

  & a {
    width: fit-content;
  }
`

const CloseBtn = styled('button')`
  background-color: transparent;
  display: flex;
  align-items: center;
  border: none;
`

const navDrawerItems = {
  primary: [
    { label: 'Best Sellers', url: '/products/bestsellers', external: false },
    { label: 'Supplements', url: '/products/supplements', external: false },
    { label: 'Bundles', url: '/products/bundles', external: false },
    { label: 'Toppers', url: '/products/toppers', external: false },
    { label: 'Dental', url: '/products/dental', external: false },
    // { label: 'Candles', url: '/products/puppy-breath-candle', external: false },
    { label: 'Grooming', url: '/products/grooming', external: false },
    { label: 'Accessories', url: '/products/accessories', external: false },
    { label: 'Take Our Quiz', url: '/consultation', external: false }
  ],
  secondary: [
    {
      label: 'Manage Subscription',
      url: 'https://shop.petfinn.com/account',
      external: true,
      socialMedia: false
    }
    // { label: 'FAQ', url: '/faq', external: false },
    // { label: 'Affiliate Program', url: '/affiliate', external: false },
    // { label: 'Press', url: 'mailto:press@petfinn.com', external: true, socialMedia: false },
    // { label: 'Terms of Use', url: '/terms', external: false },
    // { label: 'Privacy', url: '/privacy', external: false },
    // { label: 'Accessibility', url: '/accessibility', external: true }
  ]
}

interface NavDrawerProps {
  visible: boolean
  close: () => void
  pathname: any
}

const NavDrawer = ({ visible, close, pathname }: NavDrawerProps) => {
  return (
    <DrawerMenu placement="left" visible={visible} close={close} width="525px">
      <MenuWrapper>
        <div className="navDrawer__header">
          <CloseBtn onClick={close}>
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.108 2.736L10.068 9L15.108 15.264C15.432 15.66 15.612 16.164 15.612 16.56C15.612 17.244 14.856 18 14.064 18C13.452 18 12.984 17.676 12.552 17.136L8.052 11.52L3.552 17.136C3.12 17.676 2.652 18 2.04 18C1.248 18 0.492 17.244 0.492 16.56C0.492 16.164 0.672 15.66 0.996 15.264L6.036 9L0.996 2.736C0.672 2.34 0.492 1.836 0.492 1.44C0.492 0.755999 1.248 0 2.04 0C2.652 0 3.12 0.323999 3.552 0.864L8.052 6.516L12.552 0.864C12.984 0.323999 13.452 0 14.064 0C14.856 0 15.612 0.755999 15.612 1.44C15.612 1.836 15.432 2.34 15.108 2.736Z"
                fill="white"
              />
            </svg>
          </CloseBtn>

          <svg
            className="logo"
            width="51"
            height="21"
            viewBox="0 0 51 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M49.8829 18.7832C50.4372 18.7832 50.9914 19.2759 50.9914 19.8917C50.9914 20.5075 50.4988 21.0002 49.8829 21.0002C49.3287 21.0002 48.7744 20.5075 48.7744 19.8917C48.7744 19.2759 49.3287 18.7832 49.8829 18.7832ZM49.8829 20.7539C50.3756 20.7539 50.7451 20.3844 50.7451 19.8917C50.7451 19.399 50.3756 19.0295 49.8829 19.0295C49.3903 19.0295 49.0207 19.399 49.0207 19.8917C49.0207 20.3844 49.3903 20.7539 49.8829 20.7539ZM49.4518 19.2143H49.9445C50.1908 19.2143 50.3756 19.399 50.3756 19.5838C50.3756 19.8301 50.1908 19.9533 49.9445 19.9533L50.314 20.3844L50.2524 20.446H50.0677L49.6366 19.9533V20.446H49.3902V19.2143H49.4518ZM49.9445 19.7685C50.0677 19.7685 50.1293 19.707 50.1293 19.5838C50.1293 19.4606 50.0061 19.399 49.9445 19.399H49.6982V19.7685H49.9445Z"
              fill="white"
            />
            <path
              d="M7.39003 5.97361V9.23754C7.94428 7.57478 9.23754 5.66569 10.9003 5.66569V10.0997H7.39003V20.9384H2.09384V10.0997H0V5.66569H2.09384C2.09384 2.40176 3.07918 0 7.69795 0C8.80645 0 9.85337 0.123167 10.9619 0.369502V4.24927H9.85337C8.12903 4.24927 7.39003 4.55719 7.39003 5.97361Z"
              fill="white"
            />
            <path d="M17.4895 5.66602H12.1934V20.9387H17.4895V5.66602Z" fill="white" />
            <path
              d="M12.1934 2.34018C12.1934 0.985337 13.3634 0 14.8415 0C16.3195 0 17.4895 1.04692 17.4895 2.34018C17.4895 3.57185 16.3195 4.61877 14.8415 4.61877C13.3634 4.61877 12.1934 3.63343 12.1934 2.34018Z"
              fill="white"
            />
            <path
              d="M26.8496 11.5779C26.8496 10.8389 26.2338 10.2231 25.4948 10.2231C24.7558 10.2231 24.1399 10.8389 24.1399 11.5779V20.9386H18.8438V5.66589H24.1399V9.7304C24.6942 8.43715 25.9259 5.29639 28.266 5.29639C31.53 5.29639 32.0842 7.63656 32.0842 12.6248V20.9386H26.788V11.5779H26.8496Z"
              fill="white"
            />
            <path
              d="M41.5068 11.5779C41.5068 10.8389 40.891 10.2231 40.152 10.2231C39.413 10.2231 38.7972 10.8389 38.7972 11.5779V20.9386H33.501V5.66589H38.7972V9.7304C39.3514 8.43715 40.5831 5.29639 42.9233 5.29639C46.1872 5.29639 46.7414 7.63656 46.7414 12.6248V20.9386H41.4453V11.5779H41.5068Z"
              fill="white"
            />
          </svg>
        </div>
        <List>
          {navDrawerItems.primary.map((link) => (
            <NavLink key={link.label} item={link} pathname={pathname} mainItems />
          ))}
          {navDrawerItems.secondary.map((link) => (
            <NavLink key={link.label} item={link} pathname={pathname} />
          ))}
        </List>
        <MenuSocial />
        <StretchCTAButton
          copy={'Shop All'}
          bg="orange"
          color="navy"
          arrow
          onClick={() => {
            navigate('/products')
            close()
          }}
        />
      </MenuWrapper>
    </DrawerMenu>
  )
}

export default NavDrawer
